module.exports = __webpack_public_path__ + "static/media/radar.b33ef442.png";